<template>
  <div class="input-group">
    <FormLabel
      :prepend="prepend"
      :required="required">
      <select
        v-validate="validate"
        :disabled="disabled"
        :name="name"
        :value="value"
        class="form-control custom-select"
        @input="updateValue">
        <option
          v-if="placeholder"
          :selected="value === '' || value == null || value == undefined || value == NaN || value == placeholder"
          value="">{{ placeholder }}</option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
          :selected="option.value == value">{{ option.text }}</option>
      </select>
    </FormLabel>
  </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel';

export default {
  inject: ['$validator'],
  name: 'FormSelect',
  components: { FormLabel },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [String, Number],
      default: null,
    },
    prepend: {
      type: String,
      default: null,
    },
    number: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(event) {
      if (event && event.target) {
        const val = event.target.value;
        if (this.number && !Number.isNaN(parseInt(val, 10))) {
          this.$emit('input', parseInt(val, 10));
        } else {
          this.$emit('input', val);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
i {
  font-size: 10px;
}
</style>
